const billingName = 'Billing';

export const FETCH_ZUORA_CREDENTIALS = `${billingName}/FETCH_ZUORA_CREDENTIALS`;
export const FETCH_ZUORA_CREDENTIALS_RESPONSE = `${billingName}/FETCH_ZUORA_CREDENTIALS_RESPONSE`;
export const FETCH_ZUORA_CREDENTIALS_ERROR = `${billingName}/FETCH_ZUORA_CREDENTIALS_ERROR`;

export const CREDIT_CARD_UPDATE_SUCCESSFUL = `${billingName}/CREDIT_CARD_UPDATE_SUCCESSFUL`;
export const CREDIT_CARD_UPDATE_ERROR = `${billingName}/CREDIT_CARD_UPDATE_ERROR`;

export const UPDATE_DEFAULT_PAYMENT_METHOD_REQUEST = `${billingName}/UPDATE_DEFAULT_PAYMENT_METHOD_REQUEST`;
export const UPDATE_DEFAULT_PAYMENT_METHOD_SUCCESS = `${billingName}/UPDATE_DEFAULT_PAYMENT_METHOD_SUCCESS`;
export const UPDATE_DEFAULT_PAYMENT_METHOD_ERROR = `${billingName}/UPDATE_DEFAULT_PAYMENT_METHOD_ERROR`;

export const FETCH_TRIAL_EXPIRATION_DATE_REQUEST = `${billingName}/FETCH_TRIAL_EXPIRATION_DATE_REQUEST`;
export const FETCH_TRIAL_EXPIRATION_DATE_RESPONSE = `${billingName}/FETCH_TRIAL_EXPIRATION_DATE_RESPONSE`;
export const FETCH_TRIAL_EXPIRATION_DATE_ERROR = `${billingName}/FETCH_TRIAL_EXPIRATION_DATE_ERROR`;

export const UPDATE_TRIAL_EXPIRATION_DATE_REQUEST = `${billingName}/UPDATE_TRIAL_EXPIRATION_DATE_REQUEST`;
export const UPDATE_TRIAL_EXPIRATION_DATE_RESPONSE = `${billingName}/UPDATE_TRIAL_EXPIRATION_DATE_RESPONSE`;
export const UPDATE_TRIAL_EXPIRATION_DATE_ERROR = `${billingName}/UPDATE_TRIAL_EXPIRATION_DATE_ERROR`;

export const GET_CREDIT_CARDS_REQUEST = `${billingName}/GET_CREDIT_CARDS_REQUEST`;
export const GET_CREDIT_CARDS_RESPONSE = `${billingName}/GET_CREDIT_CARDS_RESPONSE`;
export const GET_CREDIT_CARDS_ERROR = `${billingName}/GET_CREDIT_CARDS_ERROR`;

export const INSERT_ZUORA_ACCOUNT_REQUEST = `${billingName}/INSERT_ZUORA_ACCOUNT_REQUEST`;
export const INSERT_ZUORA_ACCOUNT_SUCCESS = `${billingName}/INSERT_ZUORA_ACCOUNT_SUCCESS`;
export const INSERT_ZUORA_ACCOUNT_ERROR = `${billingName}/INSERT_ZUORA_ACCOUNT_ERROR`;

export const GET_ORG_USAGE_DATA_REQUEST = `${billingName}/GET_ORG_USAGE_DATA_REQUEST`;
export const GET_ORG_USAGE_DATA_SUCCESS = `${billingName}/GET_ORG_USAGE_DATA_SUCCESS`;
export const CLEAR_ORG_USAGE_DATA = `${billingName}/CLEAR_ORG_USAGE_DATA`;

// ------------ SKU TABLE MODAL ACTIONS -----------------------------------------------------------------
export const GET_ZUORA_PRODUCTS_REQUEST = `${billingName}/GET_ZUORA_PRODUCTS_REQUEST`;
export const GET_ZUORA_PRODUCTS_SUCCESS = `${billingName}/GET_ZUORA_PRODUCTS_SUCCESS`;

export const GET_ZUORA_RATEPLANS_REQUEST = `${billingName}/GET_ZUORA_RATEPLANS_REQUEST`;
export const GET_ZUORA_RATEPLANS_SUCCESS = `${billingName}/GET_ZUORA_RATEPLANS_SUCCESS`;

// ------------ ZUORA OBJECT MANIPULATION ACTIONS -------------------------------------------------------
export const CREATE_ZUORA_OBJECT_REQUEST = `${billingName}/CREATE_ZUORA_OBJECT_REQUEST`;
export const UPDATE_ZUORA_OBJECT_REQUEST = `${billingName}/UPDATE_ZUORA_OBJECT_REQUEST`;
export const DELETE_ZUORA_OBJECT_REQUEST = `${billingName}/DELETE_ZUORA_OBJECT_REQUEST`;
export const OBJECT_MANIPULATION_FINISHED = `${billingName}/OBJECT_MANIPULATION_FINISHED`;
